module.exports = __webpack_public_path__ + "img/rbis_logo.c74c6466.svg";